<template>
    <div v-if="!isMobile">
        <div class="web_chatcontainer">
            <div class="web_sidebar" :style="{ width: sidebarWidth }" v-if="browserWidth > 600">
                <div class="web_sidebar_header">
                    <img style="width: 195px;height: 60px" src="../assets/newlogo.png" v-if="!isCollapsed">
                    <img style="width: 50px;height: 50px;padding-right: 20px" src="../assets/newlogo-mini.png" v-if="isCollapsed">
                    <Icon icon="tdesign:indent-left" v-if="!isCollapsed"  @click="toggleSidebar"
                          style="padding-left: 10px;color: black;width: 25px;height: 25px"/>
                </div>
                <div class="web_sidebar_footer">
                    <div style="padding-bottom: 20px;" v-if="isCollapsed">
                        <button @click="toggleSidebar" class="web_left_button">
                            <Icon icon="tdesign:indent-right" style="height: 32px;width: 20px;"/>
                        </button>
                    </div>
                    <div style="padding-bottom: 20px;">
                        <button @click="cleanLocalMessage" :disabled="isLoading" class="web_clean_button_left" v-if="!isCollapsed">
                            <img src="../assets/btn_new_white.png" width="20px" height="20px" style="margin-right: 5px">
                            开启新对话
                        </button>
                        <button @click="cleanLocalMessage" :disabled="isLoading" class="web_clean_button_left1" v-if="isCollapsed">
                            <img src="../assets/btn_new.png" width="20px" height="20px">
                        </button>
                    </div>
                </div>
                <div style="margin-left: 20px" v-if="!isCollapsed">
                    <div style="display: flex; align-items: center;color: #999999;font-family: SourceHanSansCN;
                    font-weight: 500;margin-bottom: 5px; font-size: 15px">
                        <img src="../assets/icon_left_b.svg" width="18px" height="18px" style="margin-right: 5px">历史记录
                    </div>
                    <div class="web_msg_history" v-for="(item, index) in chatsHistory" :key="index" @click="selectChat(item.id)">
                        <div class="web_msg_history_title">{{item.title}}</div>
                        <div :id="item.id" class="web_msg_history_more" @click="showHistoryMenu(item.id)">
                            <img src="../assets/btn_more.svg">
                        </div>
                        <div class="web_msg_history_opt" v-if="item.isOpen" @click="delHistory(item.id)">
                            <img src="../assets/btn_tc_sc.svg" style="width: 22px;height: 22px;margin-right: 5px">删除
                        </div>
                    </div>
                </div>
                <div class="web_sidebar_bottom">
                    <div style="padding-bottom: 30px;padding-left: 20px;" v-if="!isCollapsed">
                        <div style="display: flex; align-items: center;color: #999999;font-family: SourceHanSansCN;
                            font-weight: 500;margin-bottom: 5px; font-size: 15px">
                            <img src="../assets/icon_left_list_b.png" width="18px" height="18px" style="margin-right: 5px">模型选择
                        </div>
                        <el-select size="large" v-model="modelname" style="width: 220px;border-radius: 10px" popper-class="web_select_elm">
                            <el-option v-for="(item, index) in modelList" :key="item.modelId" :value="item.modelId" :label="item.name"></el-option>
                        </el-select>
                    </div>
                </div>

                <div class="web_flex_c_c web_sidebar_user">
                    <button class="web_btn_info" v-if="!isCollapsed" @click="infoShow">
                        <img src="../assets/icon_my.svg" width="30px" height="30px" style="margin-right: 5px">
                        个人信息
                    </button>
                    <div class="web_fills"></div>
                    <div class="exit f14" style="cursor: pointer" v-if="!isCollapsed" @click="logout">退出登录 &gt;</div>
                    <button class="web_btn_info_coll" v-if="isCollapsed" @click="infoShow">
                        <Icon icon="ep:user-filled" style="height: 32px;width: 20px;"/>
                    </button>
                </div>
            </div>
            <div v-if="isFirst" class="web_container">
                <div class="web_chat_container_first">
                    <div style="margin-top: 90px">
                        <img style="width: 150px;height: 150px" src="../assets/uniapp_logo.png">
                        <div class="web_title_first">华证帮AI审核助手</div>
                        <div class="web_title1_first">基于海量企业案例的AI大模型，提供从模拟审核、根本原因分析到不符合项整改的全流程解决方案。</div>
                    </div>
                    <div style="display: flex;justify-content: center">
                        <button @click="promptShow" :disabled="isLoading" class="web_clean_button">
                            <img src="../assets/btn_new_white1.png" width="15px" height="15px" style="margin-right: 5px">
                            提示词
                        </button>
                    </div>
                    <div class="file_info" v-if="isFileUpload">
                        <div style="margin-left: 10px;margin-top: 5px;">
                            <el-icon :size="27" style="color: rgb(248, 202, 39);"><Document /></el-icon>
                        </div>
                        <div>
                            <div style="margin-left: 5px;margin-top: 5px;text-overflow: ellipsis;white-space: nowrap;
                            overflow: hidden;width: 200px;font-size: 14px;font-weight: 500;text-align: left">
                                {{filename}}
                            </div>
                            <div style="margin-left: 10px;cursor: pointer;text-align: left" @click="delfile">
                                <el-icon :size="13" style="color: cornflowerblue"><DeleteFilled /></el-icon>
                            </div>
                        </div>
                    </div>
                    <div class="web_input_area_first">
                        <div class="web_input_area_first1">
                        <textarea v-model="inputText" @keydown.enter.exact.prevent="isCanChatFirst"
                                  placeholder="请输入你的问题" rows="1" ref="textarea"></textarea>
                            <el-upload class="web_send_btn" accept=".doc, .docx, .txt, .pdf" :before-upload="beforeUpload"
                                       action="/ai/file/upload" :on-success="fileSuccess" :on-progress="uploading">
                                <button class="web_send_btn" :disabled="isLoading" style="padding-top: 5px">
                                    <el-icon :size="20"><Link /></el-icon>
                                </button>
                            </el-upload>
                            <button class="web_send_btn" @click="isCanChatFirst" :disabled="isLoading">
                                <Icon icon="si:down-left-fill" style="height: 32px;width: 23px"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="web_chat_container">
                <div class="web_chat_title"><div class="overf">{{currentTitle}}</div></div>
                <!-- 对话内容区域 -->
                <div class="web_messages" ref="messagesContainer">
                    <div v-for="(msg, index) in messages" :key="index" class="web_message" :class="msg.role">
                        <div class="web_avatar" v-if="msg.role == 'assistant'">
                            <img src="../assets/ai_picture.png" width="30px" height="30px">
                        </div>
                        <div class="web_content">
                            <div class="thinking" v-if="msg.thinking">
                                <div class="web_dot_flashing"></div>
                            </div>
                            <div class="web_text" style="padding-left: 15px" v-html="msg.content" v-if="msg.role == 'user'"></div>
                            <div class="web_text" v-if="msg.role == 'assistant'">
                                <ul>
                                    <li class="web_thinkli" v-html="markdown.render(msg.think)"></li>
                                    <li class="web_contnetli" v-html="markdown.render(msg.text)"></li>
                                </ul>
                            </div>
                            <div class="btn web_flex_c_c" v-if="msg.role != 'user'">
<!--                                <div class="btn-1 web_flex_c_c">
                                    <img src="../assets/btn_answer@2x.png" />
                                    重新回答
                                </div>-->
                                <div class="btn-2 web_flex_c_c" @click="copyAns(msg.id)">
                                    <img src="../assets/btn_copy@2x.png" />
                                </div>
                                <div class="web_fills"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="web_refreshdiv">
                    <button @click="promptShow" :disabled="isLoading" class="web_clean_button">
                        <img src="../assets/btn_new_white1.png" width="15px" height="15px" style="margin-right: 5px">
                        提示词
                    </button>
                    <button @click="cleanLocalMessage" :disabled="isLoading" class="web_clean_button">
                        <img src="../assets/btn_new_white.png" width="15px" height="15px" style="margin-right: 5px">
                        开启新对话
                    </button>
                </div>

                <!-- 输入区域 -->
                <div class="file_info" v-if="isFileUpload">
                    <div style="margin-left: 10px;margin-top: 5px;">
                        <el-icon :size="27" style="color: rgb(248, 202, 39);"><Document /></el-icon>
                    </div>
                    <div>
                        <div style="margin-left: 5px;margin-top: 5px;text-overflow: ellipsis;white-space: nowrap;
                            overflow: hidden;width: 200px;font-size: 14px;font-weight: 500;">
                            {{filename}}
                        </div>
                        <div style="margin-left: 10px;cursor: pointer;" @click="delfile">
                            <el-icon :size="13" style="color: cornflowerblue"><DeleteFilled /></el-icon>
                        </div>
                    </div>
                </div>
                <div class="web_input_area">
                    <div class="web_input_area1">
                        <textarea v-model="inputText" @keydown.enter.exact.prevent="isCanChat"
                                  placeholder="请输入你的问题" rows="1" ref="textarea"></textarea>
                        <button class="web_send_btn" @click="sendStop" :disabled="!isLoading" style="padding-top: 5px">
                            <el-icon :size="20"><CloseBold /></el-icon>
                        </button>
                        <el-upload class="web_send_btn" accept=".doc, .docx, .txt, .pdf" :before-upload="beforeUpload"
                                   action="/ai/file/upload" :on-success="fileSuccess" :on-progress="uploading">
                            <button class="web_send_btn" :disabled="isLoading" style="padding-top: 5px">
                                <el-icon :size="20"><Link /></el-icon>
                            </button>
                        </el-upload>
                        <button class="web_send_btn" @click="isCanChat" :disabled="isLoading" style="padding-top: 5px">
                            <el-icon :size="20"><Select /></el-icon>
                        </button>
                    </div>
                </div>
                <div style="align-items:center;text-align:center;font-family: SourceHanSansCN;color: #AFAFAF;
                    font-size: 15px;font-weight: 400;margin-top: 15px">
                    内容由ai生成，请仔细甄别
                </div>
            </div>
        </div>
        <el-dialog v-model="loginVisible" title="登录" width="350" align-center center v-loading.fullscreen.lock="fullscreenLoading" class="web_dialog_elm">
            <div style="padding: 10px">
                <input v-model="userphone" style="width: 285px" class="web_text_login"/>
            </div>
            <div style="padding: 10px;">
                <input v-model="vcode" style="width: 165px" class="web_text_login"/>
                <button @click="sendVcode" :disabled="isSend" style="width: 100px;height: 40px;margin-left: 15px;border-radius: 10px;" class="web_send_btn">
                    {{buttonText}}
                </button>
            </div>
            <div style="text-align:center;margin-top: 20px">
                <button @click="login" style="width: 295px;height: 40px;border-radius: 10px;" class="web_send_btn">登录</button>
            </div>
            <div style="text-align:center;margin-top: 10px">
                <button @click="regi" style="width: 295px;height: 40px;border-radius: 10px;" class="web_send_btn">注册</button>
            </div>
<!--            <div style="text-align:center;margin-top: 10px">
                <button @click="wxlogin" style="width: 295px;height: 40px;border-radius: 10px;" class="wechat_login_btn">微信登录</button>
            </div>-->
            <div style="text-align:center;margin-top: 20px"></div>
        </el-dialog>
        <el-dialog v-model="infoVisible" title="个人信息" width="600" center align-center class="web_dialog_elm">
            <el-tabs class="tabs-elm">
                <el-tab-pane label="账号信息">
                    <el-descriptions direction="vertical" border>
                        <el-descriptions-item :rowspan="2" :width="140" align="center" label-class-name="user-info">
                            <img style="width: 100px; height: 100px; margin-top: 10px" src="../assets/default_avatar.png" v-if="userAvatar == 'default'"/>
                            <img style="width: 100px; height: 100px; margin-top: 10px" :src="userAvatar" v-else/>
                        </el-descriptions-item>
                        <el-descriptions-item label="账号" label-class-name="user-info">{{userphone}}</el-descriptions-item>
                        <el-descriptions-item label="当日剩余次数" label-class-name="user-info"><span style="color: red">{{aicount}}</span></el-descriptions-item>
                        <el-descriptions-item label="企业VIP到期(每日免费30次)" label-class-name="user-info">{{vipEnterpriseEndDate}}</el-descriptions-item>
                        <el-descriptions-item label="服务商VIP到期(每日免费30次)" label-class-name="user-info">{{vipProviderEndDate}}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane label="服务协议">
                    <div style="display: flex;justify-content: space-between;">
                        <div><span style="font-family: 'Microsoft Sans Serif';font-weight: 500">用户协议</span></div>
                        <div><el-button size="small" round @click="serviceDraw(1)">查看</el-button></div>
                    </div>
                    <el-divider style="margin: 10px 0"/>
                    <div style="display: flex;justify-content: space-between;">
                        <div><span style="font-family: 'Microsoft Sans Serif';font-weight: 500">隐私政策</span></div>
                        <div><el-button size="small" round @click="serviceDraw(2)">查看</el-button></div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <el-dialog v-model="promptVisible" title="提示词" width="900" center align-center class="web_dialog_elm">
            <el-table :data="tableData" style="width: 100%;height:510px">
                <el-table-column prop="sn" label="序号" width="60" />
                <el-table-column prop="name" label="名称" width="135" />
                <el-table-column prop="content" label="内容" width="600" />
                <el-table-column width="70" label="操作">
                    <template #default="scope">
                        <el-button link type="primary" size="small" @click="prompt(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog v-model="registerVisible" title="注册" width="250" align-center>
            <img style="width: 150px;height: 150px;margin-left: 35px" src="../assets/uniapp_logo.png">
            <div class="web_regi_text">请扫描二维码进入小程序注册</div>
        </el-dialog>
        <el-dialog v-model="wxloginVisible" title="微信扫码登录" width="250" align-center>
            <qrcode-vue v-if="qrValue" :value="qrValue" :size="200" level="H" />
            <p v-if="wxloginmessage">{{ wxloginmessage }}</p>
        </el-dialog>
        <el-drawer v-model="drawer" :with-header="false">
            <iframe :src="drawerUrl" frameborder="0" width="100%" height="100%"></iframe>
        </el-drawer>
    </div>
</template>

<script setup>
import {ref, reactive, nextTick, onMounted, watch, computed, onUnmounted, onBeforeUnmount} from 'vue'
import markdownIt from 'markdown-it';
import markdownItContainer from 'markdown-it-task-lists';
import { Icon } from '@iconify/vue';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import {
    model_list,
    send_vcode,
    user_info,
    user_login,
    settle_count,
    user_logout,
    describe_file,
    wxlogin_qrcode
} from "@/api/chat";
import MobileDetect from 'mobile-detect';
import {chatUrl} from "@/js/chat";
import QrcodeVue from 'qrcode.vue';
// 消息列表
const isCollapsed = ref(false);
const loginVisible = ref(false);
const infoVisible = ref(false);
const promptVisible = ref(false);
const registerVisible = ref(false);
const wxloginVisible = ref(false);
const isSend = ref(false);
const fullscreenLoading = ref(false)
const messages = reactive([]);
const inputText = ref('');
const isLoading = ref(false);
const isMobile = ref(false);
const isFileUpload = ref(false);
const messagesContainer = ref(null);
const textarea = ref(null);
const isFirst = ref(true);
const markdown = new markdownIt({
    html: true,// 启用HTML标签
    breaks: true,// 转换换行符为<br>
    linkify: true, // 自动转换URL为链接
    typographer: true // 启用语言中性的替换
});
markdown.use(markdownItContainer, {enable: true});
const sessionId = ref('');
const currentTitle = ref('');
const buttonText = ref('获取验证码');
const sidebarWidth = computed(() => {
    return isCollapsed.value ? '68px' : '260px'
});
let eventSource;
const browserWidth = ref(0);
const delHistoryId = ref(0);
const countdownTime = ref(60);
const chatsHistory = reactive([]);
const modelList = ref([]);
const userphone = ref('');
const userAvatar = ref('');
const aicount = ref('');
const vipEnterpriseEndDate = ref('');
const vipProviderEndDate = ref('');
const vcode = ref('');
const revcode = ref('');
const modelkey = ref('');
const modelname = ref('');
const filename = ref('');
const fileRequestId = ref('');
const md = new MobileDetect(window.navigator.userAgent);
let uploadInstance = ref(null);
const drawer = ref(false);
const drawerUrl = ref('');
const qrValue = ref('');
const wxloginmessage = ref('生成二维码中...');
const state = ref('');
const tableData = [
    {
        sn: 1,
        name: '不符合项整改',
        content: '我司的认证范围是：_____的设计和生产。目前在接受认证机构IATF16949认证审核。被审核组开具了__个一般不符合项：如“S3设施和工装、模具管理”。 具体内容：1）客观证据：_____；2）分类理由：_____。请按照IATF-CARA系统的格式（S1-S7样式）给我生成一份不符合项关闭报告，保证不符合项能彻底关闭。越详细越好，谢谢！'
    },
    {
        sn: 2,
        name: '标准条款解读',
        content: '请解释ISO9001:2015中条款8.5.1‘生产和服务提供的控制’的要求和常见实施证据'
    },
    {
        sn: 3,
        name: '工具应用指导',
        content: '如何运用APQP第五阶段‘反馈和纠正措施’来响应客户投诉？'
    },
    {
        sn: 4,
        name: '考试题库练习',
        content: '请给我5道关于IATF16949风险思维的多选题，并提供答案和解析'
    },
    {
        sn: 5,
        name: '文件模板生成',
        content: '生成一份ISO14001:2015‘环境目标管理方案’的模板，包含目标和指标跟踪表。'
    },
    {
        sn: 6,
        name: '多标准交叉查询',
        content: '比较ISO45001中‘应急准备’要求与IATF16949中‘应急计划’要求的异同'
    },
    {
        sn: 7,
        name: '最佳实践案例',
        content: '展示其他企业在处理‘内部审核有效性不足’问题时的成功整改案例。'
    },
    {
        sn: 8,
        name: '风险识别与预防',
        content: '根据以往审核数据，哪些过程容易出现‘设备维护不足’的不符合？如何预防？'
    },
    {
        sn: 9,
        name: '供应商审核要点',
        content: '针对采购过程，IATF16949和VDA6.3对供应商管理有哪些关键审核要求？'
    },
    {
        sn: 10,
        name: '法规符合性检查',
        content: '我们工厂在环保方面需要满足哪些中国法规？如何体现在ISO14001体系中？'
    }
]

// 自动调整输入框高度
const adjustTextareaHeight = () => {
    textarea.value.style.height = 'auto'
    textarea.value.style.height = textarea.value.scrollHeight + 'px'
}

// 发送消息
const sendMessage = async () => {
    if (!inputText.value.trim()) return;
    if (isLoading.value) return;
    let prompt = inputText.value.trim();
    if(localStorage.getItem("current_local_title") == null) {
        localStorage.setItem("current_local_title", prompt);
        currentTitle.value = prompt;
    }

    let fri = "";
    let fn = "";
    if (fileRequestId.value.trim() != '') {
        fri = fileRequestId.value;
        let frs = await describe_file(fri);
        console.log(frs);
        if (frs.code != 200) {
            ElMessage.error("文件错误请重新上传");
            return false;
        } else {
            if (frs.Status != "FILE_IS_READY") {
                ElMessage.error("文件尚未解析完成");
                return false;
            }
        }

        fn = "  (" + filename.value + ")";
        isFileUpload.value = false;
        filename.value = "";
        fileRequestId.value = "";
    }

    let uid = new Date().getTime();
    // 添加用户消息
    messages.push({
        id: uid,
        role: 'user',
        content: inputText.value.trim() + fn,
        thinking: false
    })

    localStorage.setItem("current_local_messages", JSON.stringify(messages));

    inputText.value = ''
    isLoading.value = true

    await nextTick()
    messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight

    let url = chatUrl;
    url += "?prompt=" + encodeURIComponent(prompt);
    url += "&modelkey=" + modelkey.value;
    url += "&sessionId=" + sessionId.value;
    url += "&fileId=" + fri;
    //url += "&fileId=file_session_1a86cbeca7f74cbc94a6a0355ce59e66_11308471"

    console.log(url);
    eventSource = new EventSource(url);

    // 添加 AI 响应占位
    let mid = new Date().getTime();
    messages.push({
        id: mid,
        role: 'assistant',
        content: '',
        think: '',
        text: '',
        thinking: true
    })

    let issettle = false;
    eventSource.onmessage = function (event) {
        if (!issettle) {
            settleCount();
            issettle = true;
        }
        let j = JSON.parse(event.data);
        sessionId.value = j.sessionId;
        localStorage.setItem("current_local_sessionId", sessionId.value);
        let think = "";
        let text = "";
        if (j.isThink) {
            think = j.think;
            messages[messages.length - 1].think += think;
        } else {
            text = j.text;
            text = text.replace('<br>','');
            messages[messages.length - 1].text += text;
        }
        if (j.isFinish) {
            eventSource.close();
            storeCurrent();
        }
        messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
    };

    eventSource.onerror = (error) => {
        messages[messages.length - 1].text = '服务器连接超时，请重新提问';
        storeCurrent();
        eventSource.close();
    };

    eventSource.onopen = function () {
    };
}

function sendStop() {
    storeCurrent();
    eventSource.close();
}

function storeLocalMessage() {
    if (localStorage.getItem("current_local_title") != null && localStorage.getItem("current_local_messages") != null) {
        if (localStorage.getItem("current_local_id") == null) {
            let id = new Date().getTime();
            localStorage.setItem("current_local_id", id);
            let chat = {
                "id" : id,
                "title" : localStorage.getItem("current_local_title"),
                "messages" : localStorage.getItem("current_local_messages"),
                "sessionId" : localStorage.getItem("current_local_sessionId"),
                "isOpen" : false
            }
            if (localStorage.getItem("chats") != null) {
                let chats = JSON.parse(localStorage.getItem("chats"));
                if (chats.length < 7) {
                    chats.push(chat);
                    localStorage.setItem("chats", JSON.stringify(chats));
                } else {
                    let newchats = [];
                    for (let x = 1;x < chats.length;x++) {
                        newchats.push(chats[x]);
                    }
                    newchats.push(chat);
                    localStorage.setItem("chats", JSON.stringify(newchats));
                }
            } else {
                let chats = [];
                chats.push(chat);
                localStorage.setItem("chats", JSON.stringify(chats));
            }
        } else {
            let id = localStorage.getItem("current_local_id");
            let chat = {
                "id" : id,
                "title" : localStorage.getItem("current_local_title"),
                "messages" : localStorage.getItem("current_local_messages"),
                "sessionId" : localStorage.getItem("current_local_sessionId"),
                "isOpen" : false
            }
            if (localStorage.getItem("chats") != null) {
                let chats = JSON.parse(localStorage.getItem("chats"));
                let newchats = [];
                for (let x = 0;x < chats.length;x++) {
                    if (chats[x].id == id)
                        newchats.push(chat);
                    else
                        newchats.push(chats[x]);
                }
                localStorage.setItem("chats", JSON.stringify(newchats));
            } else {
                let chats = [];
                chats.push(chat);
                localStorage.setItem("chats", JSON.stringify(chats));
            }
        }
    }

    if (localStorage.getItem("chats") != null) {
        isFirst.value = false;
        chatsHistory.length = 0;
        let chats = JSON.parse(localStorage.getItem("chats"));
        for (let x = 0;x < chats.length;x++) {
            chatsHistory.push(chats[x]);
        }
    }
}

function cleanLocalMessage() {
    storeLocalMessage();
    localStorage.removeItem('current_local_id')
    localStorage.removeItem('current_local_title')
    localStorage.removeItem('current_local_messages')
    localStorage.removeItem('current_local_sessionId')
    currentTitle.value = '';
    sessionId.value = '';
    messages.length = 0;
    isFirst.value = true;
}

async function isCanChatFirst() {
    if (localStorage.getItem("user_token") != null) {
        if (localStorage.getItem("user_token").length > 0) {
            let user = await user_info();
            if (user != undefined) {
                if (user.aiCount > 0) {
                    sendMessageFirst()
                } else {
                    ElMessage.error({message: '当天咨询AI助手次数已使用完'});
                }
            } else {
                loginVisible.value = true;
            }
        } else {
            loginVisible.value = true;
        }
    } else {
        loginVisible.value = true;
    }
}

function sendMessageFirst() {
    if (!inputText.value.trim()) return;
    if (isLoading.value) return;
    sendMessage();
    isFirst.value = false;
}

const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value
}

function setBrowserWidth() {
    browserWidth.value = window.innerWidth;
}

function showHistoryMenu(id) {
    chatsHistory.forEach(his =>{
        if (id == his.id)
            his.isOpen = true;
        else
            his.isOpen = false;
    })
}

function hideDiv(event) {
    let articleList = document.querySelectorAll(".web_msg_history_more");
    let ishid = true;
    for (let item of articleList) {
        if (event.target == item) {
            ishid = false;
            break;
        }
    }
    if (ishid) {
        chatsHistory.forEach(his =>{
            his.isOpen = false;
        })
    }
}

document.addEventListener('click', hideDiv);

function storeCurrent() {
    isLoading.value = false;
    messages[messages.length - 1].thinking = false
    localStorage.setItem("current_local_messages", JSON.stringify(messages));

    storeLocalMessage();
}

function selectChat(id) {
    if (isLoading.value) {
        ElMessage.error("AI对话还未完成");
    } else {
        messages.length = 0;
        isFirst.value = false;
        let chats = JSON.parse(localStorage.getItem("chats"));
        chats.forEach(chat => {
            if (id == chat.id) {
                let message_jsons = eval('(' + chat.messages + ')');
                message_jsons.forEach(json => {
                    messages.push(json);
                });
                currentTitle.value = chat.title;
                localStorage.setItem("current_local_id", id);
                localStorage.setItem("current_local_messages", JSON.stringify(messages));
                localStorage.setItem("current_local_title", chat.title);
                localStorage.setItem("current_local_sessionId", chat.sessionId);
            }
        });
    }
    //window.location.href = "/"
}

function delHistory(id) {
    ElMessageBox.confirm('是否删除历史记录?', '提示',{
        customStyle: {"border-radius": "10px"},
        autofocus: false,
        confirmButtonClass: 'web_btn_elm_ok',
        cancelButtonClass: 'web_btn_elm_can',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
    })
        .then(() => {
            delHistoryId.value = id;
            delSubmit()
        })
        .catch(() => {
        })
}

function delSubmit() {
    if (delHistoryId.value != 0) {
        let id = delHistoryId.value;
        if (localStorage.getItem("chats") != null) {
            let chats = JSON.parse(localStorage.getItem("chats"));
            let newchats = [];
            for (let x = 0;x < chats.length;x++) {
                if (chats[x].id != id)
                    newchats.push(chats[x]);
            }
            localStorage.setItem("chats", JSON.stringify(newchats));
        }
    }
    if (localStorage.getItem("chats") != null) {
        isFirst.value = false;
        chatsHistory.length = 0;
        let chats = JSON.parse(localStorage.getItem("chats"));
        for (let x = 0;x < chats.length;x++) {
            chatsHistory.push(chats[x]);
        }
    }
    localStorage.removeItem('current_local_id')
    localStorage.removeItem('current_local_title')
    localStorage.removeItem('current_local_messages')
    localStorage.removeItem('current_local_sessionId')
    currentTitle.value = '';
    messages.length = 0;
}

async function isCanChat() {
    if (localStorage.getItem("user_token") != null) {
        if (localStorage.getItem("user_token").length > 0) {
            let user = await user_info();
            if (user != undefined) {
                if (user.aiCount > 0) {
                    sendMessage()
                } else {
                    ElMessage.error({message: '当天咨询AI助手次数已使用完'});
                }
            } else {
                loginVisible.value = true;
            }
        } else {
            loginVisible.value = true;
        }
    } else {
        loginVisible.value = true;
    }
    //屏蔽代码误删
    //sendMessage();
}

const updateCountdown = () => {
    if (countdownTime.value > 0) {
        countdownTime.value--;
        buttonText.value = countdownTime.value + ' 获取验证码';
    } else {
        isSend.value = false;
        buttonText.value = '获取验证码';
        countdownTime.value = 60; // 重置倒计时时间
    }
};

const startCountdown = () => {
    if (!isSend.value) {
        isSend.value = true;
        buttonText.value = countdownTime.value + ' 获取验证码';
        const interval = setInterval(() => {
            updateCountdown();
            if (countdownTime.value === 0) {
                isSend.value = false;
                buttonText.value = '获取验证码';
                countdownTime.value = 60;
                clearInterval(interval);
            }
        }, 1000);
    }
};

async function sendVcode() {
    const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!regex.test(userphone.value)) {
        ElMessage.error({message: '手机号格式不正确'});
    } else {
        let vc = await send_vcode(userphone.value);
        if (vc != undefined && vc.code == 200) {
            revcode.value = vc.object;
            startCountdown();
            isSend.value = true;
        }
    }
}

async function login() {
    if (userphone.value == '' || vcode.value == '') {
        ElMessage.error({message: '请输入手机号和验证码'})
    } else if (vcode.value != revcode.value) {
        ElMessage.error({message: '验证码不正确'})
    } else {
        fullscreenLoading.value = true
        var params = new URLSearchParams();
        params.append('username', userphone.value);
        params.append('password', vcode.value);
        let rs = await user_login(params);
        if (rs != undefined && rs.code == 200) {
            localStorage.setItem("user_token", rs.object.access_token);
            let user = await user_info();
        }
        fullscreenLoading.value = false;
        loginVisible.value = false;
    }
}

function logout() {
    if (localStorage.getItem("user_token") != null) {
        ElMessageBox.confirm('是否退出？', '提示', {
            customStyle: {"border-radius": "10px"},
            autofocus: false,
            confirmButtonClass: 'web_btn_elm_ok',
            cancelButtonClass: 'web_btn_elm_can',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                out();
            })
            .catch(() => {
            })
    } else {
        ElMessage.error("未登录");
    }
}

async function out() {
    let rs = await user_logout();
    if (rs.code == 200) {
        localStorage.removeItem("user_token");
    }
}

async function settleCount() {
    await settle_count();
}

async function infoShow() {
    let user = await user_info();
    if (user != undefined) {
        infoVisible.value = true;
        userphone.value = user.username;
        aicount.value = user.aiCount;
        vipEnterpriseEndDate.value = user.enterpriseVipEndDate;
        vipProviderEndDate.value = user.providerVipEndDate;
        userAvatar.value = user.userAvatar;
    } else {
        loginVisible.value = true;
    }
}

function promptShow() {
    promptVisible.value = true;
}

const copyAns = (id) => {
    if(isLoading.value) {
        ElMessage.warning("请等待AI完成回答");
        return;
    }
    if (localStorage.getItem("current_local_messages") != null) {
        if (localStorage.getItem("current_local_messages").length > 0) {
            let message_jsons = eval('(' + localStorage.getItem("current_local_messages") + ')');
            message_jsons.forEach(json => {
                if (json.id == id) {
                    let t = json.text;
                    copyText(t);
                }
            });
        }
    }
}

async function copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
        ElMessage.success("复制成功");
    } catch (err) {
        ElMessage.error("复制失败");
    }
}

const regi = () => {
    registerVisible.value = !registerVisible.value;
}

const wxlogin = async () => {
    /*wxloginVisible.value = !wxloginVisible.value;
    fetchQRCode();*/
    try {
        const response = await wxlogin_qrcode();
        console.log(response);
        //qrValue.value = response.url;
        let wxurl = response.url;
        console.log(wxurl);
        console.log(wxurl.includes("https://open.weixin.qq.com/connect/qrconnect"));
        if (wxurl.includes("https://open.weixin.qq.com/connect/qrconnect")) {
            window.location.href = wxurl;
        } else {
            ElMessage.error("微信授权失败");
        }
        //state.value = response.data.state; // 保存state用于轮询
        //startPolling(); // 开始轮询登录状态
    } catch (error) {
        ElMessage.error("微信授权失败");
    }
}

const fetchQRCode = async () => {
    try {
        const response = await wxlogin_qrcode();
        console.log(response);
        qrValue.value = response.url;
        //state.value = response.data.state; // 保存state用于轮询
        //startPolling(); // 开始轮询登录状态
    } catch (error) {
        wxloginmessage.value = '二维码获取失败';
    }
};

async function beforeUpload(rawFile) {
    if (localStorage.getItem("user_token") != null) {
        if (localStorage.getItem("user_token").length > 0) {
            let user = await user_info();
            if (user != undefined) {
                console.log("asdasd");
                if (rawFile.size > 3000000) {
                    ElMessage.error("请上传小于3兆的文件");
                    return false;
                }
            } else {
                loginVisible.value = true;
                return false;
            }
        } else {
            loginVisible.value = true;
            return false;
        }
    } else {
        loginVisible.value = true;
        return false;
    }
};

async function fileSuccess(response, file, fileList) {
    if (response.code == 200) {
        let obj = await describe_file(response.object.FileId);
        console.log(obj);
        if (obj.code == 200) {
            filename.value = response.object.fileName;
            fileRequestId.value = response.object.FileId;
            isFileUpload.value = true;
            ElMessage.success("文件上传成功");
        } else {
            filename.value = "";
            fileRequestId.value = "";
            isFileUpload.value = false;
            ElMessage.error("上传失败");
        }
    } else {
        filename.value = "";
        fileRequestId.value = "";
        isFileUpload.value = false;
        ElMessage.error("上传失败");
    }
    uploadInstance.value.close();
}

const delfile = () => {
    isFileUpload.value = false;
    filename.value = "";
    fileRequestId.value = "";
}

const uploading = () => {
    uploadInstance.value = ElLoading.service({
        body: true,
        text: '文件解析中...',
    })
}

const serviceDraw = (type) => {
    if (type == 1)
        drawerUrl.value = "https://cnboss.cn/aiyhxy.html";
    else if (type == 2)
        drawerUrl.value = "https://cnboss.cn/aiysxy.html";
    drawer.value = true;
}

function prompt(data) {
    inputText.value = data.content;
    promptVisible.value = false;
    nextTick(() => {
        if (inputText.value) {
            textarea.value.style.height = 'auto'
            textarea.value.style.height = textarea.value.scrollHeight + 'px'
        }
    })
    /*adjustTextareaHeight();*/
}

// 自动调整输入框
watch(inputText, adjustTextareaHeight)

onMounted(async () => {
    setBrowserWidth();
    window.addEventListener('resize', setBrowserWidth);

    if (md.mobile()) {
        isMobile.value = true;
        ElMessage.error("请在PC浏览器上使用");
    }
    //localStorage.clear();

    if (localStorage.getItem("current_local_messages") != null) {
        if (localStorage.getItem("current_local_messages").length > 0) {
            let message_jsons = eval('(' + localStorage.getItem("current_local_messages") + ')');
            message_jsons.forEach(json => {
                messages.push(json);
            });
            isFirst.value = false;
            await nextTick()
            messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
        }
    }

    if (localStorage.getItem("current_local_title") != null) {
        currentTitle.value = localStorage.getItem("current_local_title");
    }

    if (localStorage.getItem("chats") != null) {
        if(JSON.parse(localStorage.getItem("chats")).length > 0) {
            let chats = JSON.parse(localStorage.getItem("chats"));
            for (let x = 0;x < chats.length;x++) {
                chatsHistory.push(chats[x]);
            }
        }
    }

    modelList.value = await model_list();
    if (localStorage.getItem("current_local_modelkey") == null || localStorage.getItem("current_local_modelkey").length < 1) {
        localStorage.setItem("current_local_modelkey", modelList.value[0].modelId);
        modelkey.value = modelList.value[0].modelId;
        modelname.value = modelList.value[0].name;
    } else {
        var isok = false;
        modelkey.value = localStorage.getItem("current_local_modelkey");
        modelList.value.forEach(json => {
            if(json.modelId == modelkey.value) {
                modelname.value = json.name;
                isok = true;
            }
        });
        if (!isok) {
            localStorage.setItem("current_local_modelkey", modelList.value[0].modelId);
            modelkey.value = modelList.value[0].modelId;
            modelname.value = modelList.value[0].name;
        }
    }

    if (localStorage.getItem("current_local_sessionId") != null) {
        sessionId.value = localStorage.getItem("current_local_sessionId");
    }

})

onUnmounted(() => {
    document.removeEventListener('click', hideDiv);
});
</script>

<style lang="scss" src="@/style/chat/chat.scss"/>
